import { render, staticRenderFns } from "./InvoicePrinterSettings.vue?vue&type=template&id=b5b07ab0"
import script from "./InvoicePrinterSettings.vue?vue&type=script&lang=js"
export * from "./InvoicePrinterSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports